export const getHandleHref = (handle: string) => `/${handle}`
